module.exports = __webpack_public_path__ + "img/2.3615e3cc.jpg";